import { jsPDF } from "jspdf";
import Roboto from "../assets/fonts/roboto-regular-normal";

Roboto(jsPDF);

const FONT_SIZE = 9;
const DEFAULT_OFFSET = 5;
const DEFAULT_QR_SIZE = 120;

export class QrService {
  constructor() {
    /**
     *
     * @type {module:jspdf.jsPDF}
     */
    this.doc = new jsPDF("p", "mm", [55.5, 60]);
    this.doc.setFontSize(FONT_SIZE);
    this.doc.setFont("roboto-regular", "normal");
    this.doc.deletePage(1);
  }

  add(data) {
    this.doc.addPage();
    this.offset = {
      top: DEFAULT_OFFSET,
      left: DEFAULT_OFFSET,
    };
    data.texts.forEach((text) => {
      this.doc.text(text, this.offset.left, this.offset.top);
      this.offset.top += 4;
    });
    this.doc.addImage(
      data.qr,
      "png",
      this.offset.left,
      this.offset.top - 2,
      data.qrSize || DEFAULT_QR_SIZE,
      data.qrSize || DEFAULT_QR_SIZE
    );
  }

  show() {
    this.doc.output("dataurlnewwindow", { filename: "qr-code" });
  }

  save(name) {
    if (!name) name = "qr_codes";
    this.doc.save(name + ".pdf");
  }
}
